import React from "react";
import { Paper } from "material-ui";

class Unauthorized extends React.Component {
  getStyles() {
    return {
      content: {
        maxWidth: 600,
        padding: 20,
        textAlign: "center",
        margin: "10vh auto 0"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      missingRoutes =
        this.props.location.state && this.props.location.state.missing;

    return (
      <Paper zIndex={2} style={styles.content}>
        <h2>Unauthorized</h2>
        <div>Sorry, you're not allowed to access this page.</div>
        {missingRoutes ? (
          <div>
            Missing permission: <code>{missingRoutes.join(",")}</code>
          </div>
        ) : null}
      </Paper>
    );
  }
}

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/app/components/unauthorized.jsx